module.exports = "https://static.zego.com/_next/static/images/ShieldTick-ff9c08956472b8229caa966a034f04cb.svg";